import React from 'react'
import { Form, Select, Input } from 'antd'

const { TextArea } = Input

/**
 * Sección de categorías del formulario
 */
const CategoriaSection = ({
  form,
  material,
  categorias,
  subCategorias,
  segmentos,
  subSegmentos,
  marcas,
  estadosDefinidos,
  isReadOnly,
  camposFaltantes,
  getFieldValidation,
  onCampoChange,
  onCategoriaChange,
  onSubcategoriaChange,
  onSegmentoChange,
  // Con cascada activa un nivel queda deshabilitado hasta que su padre esté
  // seleccionado (sus opciones se cargan filtradas por el padre)
  cascadaActiva = false,
}) => (
    <>
      <Form.Item
        label={
          <span>
             Categoría
            <span style={{ color: '#888', fontSize: '12px', fontWeight: 'normal' }}>
              | {categorias.find(c => c.id === material.repuesto_categoria_id)?.nombre ?? material.categoria_nombre}
            </span>
          </span>
        }
        name="categoria"
        rules={[{ required: true, message: 'Campo requerido' }]}
        {...getFieldValidation('categoria')}
      >
        <Select 
          placeholder="Seleccione categoría"
          disabled={isReadOnly}
          getPopupContainer={(trigger) => trigger.parentNode}
          onChange={(value) => {
            if (onCategoriaChange) onCategoriaChange(value)
            onCampoChange('categoria')
          }}
        >
          {categorias.map((cat) => (
            <Select.Option key={cat.id} value={cat.id}>
              {cat.nombre} 
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item 
       label={
        <span>
           Subcategoría{' '}
          <span style={{ color: '#888', fontSize: '12px', fontWeight: 'normal' }}>
            | {subCategorias.find(c => c.id === material.repuesto_subcategoria_id)?.nombre ?? material.subcategoria_nombre}
          </span>
        </span>
      }
        name="subcategoria"
        {...getFieldValidation('subcategoria')}
      >
        <Select
          placeholder={cascadaActiva && subCategorias.length === 0 ? 'Seleccione categoría primero' : 'Seleccione subcategoría'}
          disabled={isReadOnly || (cascadaActiva && subCategorias.length === 0)}
          getPopupContainer={(trigger) => trigger.parentNode}
          onChange={(value) => {
            if (onSubcategoriaChange) onSubcategoriaChange(value)
            onCampoChange('subcategoria')
          }}
        >
          {subCategorias.map((subcat) => (
            <Select.Option key={subcat.id} value={subcat.id}>
              {subcat.nombre}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item 
        label={
          <span>
             Segmento{' '}
            <span style={{ color: '#888', fontSize: '12px', fontWeight: 'normal' }}>
              | {segmentos.find(s => s.id === material.repuesto_segmento_id)?.nombre ?? material.segmento_nombre}
            </span>
          </span>
        }
        name="segmento"
        {...getFieldValidation('segmento')}
      >
        <Select
          placeholder={cascadaActiva && segmentos.length === 0 ? 'Seleccione subcategoría primero' : 'Seleccione segmento'}
          disabled={isReadOnly || (cascadaActiva && segmentos.length === 0)}
          getPopupContainer={(trigger) => trigger.parentNode}
          onChange={(value) => {
            if (onSegmentoChange) onSegmentoChange(value)
            onCampoChange('segmento')
          }}
        >
          {segmentos.map((segment) => (
            <Select.Option key={segment.id} value={segment.id}>
              {segment.nombre}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item 
       label={
        <span>
           Subsegmento{' '}
          <span style={{ color: '#888', fontSize: '12px', fontWeight: 'normal' }}>
            | {subSegmentos.find(s => s.id === material.repuesto_subsegmento_id)?.nombre ?? material.subsegmento_nombre}
          </span>
        </span>
      }
        name="subsegmento"
        {...getFieldValidation('subsegmento')}
      >
        <Select
          placeholder={cascadaActiva && subSegmentos.length === 0 ? 'Seleccione segmento primero' : 'Seleccione subsegmento'}
          disabled={isReadOnly || (cascadaActiva && subSegmentos.length === 0)}
          getPopupContainer={(trigger) => trigger.parentNode}
          onChange={() => onCampoChange('subsegmento')}
        >
          {subSegmentos.map((subsegment) => (
            <Select.Option key={subsegment.id} value={subsegment.id}>
              {subsegment.nombre}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item 
       label={
        <span>
           Marca{' '}
          <span style={{ color: '#888', fontSize: '12px', fontWeight: 'normal' }}>
            | {marcas.find(m => m.id === material.repuesto_marca_id)?.nombre}
          </span>
        </span>
      }
        name="marca"
        rules={[{ required: true, message: 'Campo requerido' }]}
        {...getFieldValidation('marca')}
      >
        <Select 
          placeholder="Seleccione marca"
          disabled={isReadOnly}
          getPopupContainer={(trigger) => trigger.parentNode}
          onChange={() => onCampoChange('marca')}
        >
          {marcas.map((marca) => (
            <Select.Option key={marca.id} value={marca.id}>
              {marca.nombre}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item 
       label={
        <span>
           Estado Definido{' '}
          <span style={{ color: '#888', fontSize: '12px', fontWeight: 'normal' }}>
            | {material.repuesto_estado_m0}
          </span>
        </span>
      }
        name="estadoDefinido"
        {...getFieldValidation('estadoDefinido')}
      >
        <Select 
          placeholder="Seleccione estado"
          disabled={isReadOnly}
          getPopupContainer={(trigger) => trigger.parentNode}
          onChange={() => onCampoChange('estadoDefinido')}
        >
          {estadosDefinidos.map((estado) => (
            <Select.Option key={estado} value={estado}>
              {estado}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item 
        label="Uso / Aplicación" 
        name="usoAplicacion"
        {...getFieldValidation('usoAplicacion')}
      >
        <TextArea
          rows={2}
          placeholder="uso / aplicación"
          style={{ resize: 'none' }}
          disabled={isReadOnly}
          onChange={(e) => {
            form.setFieldsValue({
              usoAplicacion: e.target.value.toUpperCase(),
            })
            onCampoChange('usoAplicacion')
          }}
        />
      </Form.Item>
    </>
  )

export default CategoriaSection
